import React, { useEffect } from 'react';
import config from './config/config';
import Routes from './config/routes';

// 🔹 Import do react-toastify
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

  useEffect(() => {
    // auto ajuste de zoom (para Windows 11)
    if (window?.devicePixelRatio && Math.round(window.devicePixelRatio * 100) === 125) {
      document.body.style.zoom = 0.98;
    }

    config.load();
  }, []);

  return (
    <div className="app">
      <Routes />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
    </div>
  );
}

export default App;